(function ($) {
    $(function () {
        // if (!$(".js-form-download").length) {
        //     return;
        // }

        $(".js-form-modal").iziModal({
            appendTo: 'body',
            appendToOverlay: 'body', 
            overlay: true,
            overlayColor: 'rgba(12, 12, 12, 0.6)',
            transitionIn: 'comingIn',
            transitionOut: 'comingOut',
            transitionInOverlay: 'fadeIn',
            transitionOutOverlay: 'fadeOut',
        });

        $('.js-close-modal').on('click', function(){
            $(".js-form-modal").iziModal('close');
        });
    });
})(jQuery);